module.exports = __webpack_public_path__ + "assets/img/MRT.b7be658b.png";